module.exports = __webpack_public_path__ + "img/icon-expand.eb421f80.svg";